import type { FaireProductEntity } from "../../entity_types/product";

export const p_tryaj5zpn7: FaireProductEntity = {
  token: "p_tryaj5zpn7",
  type: "product",
  name: "Calming Dog Charms EMF Protection Dog Bone over 25 pounds",
  brandToken: "b_qpub74vn67",
  brandName: "Secret Synergy Stones",
  imageUrl:
    "https://cdn.faire.com/fastly/e88b8a941b1f510b5cc3804a8b4dbec2c875cba9629ec8610b490eb2082fe7ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f8c528ed8e802b5ef3399e73f22bfb4c86b7c85c9ad5853cc72f6ffddbbda71.jpeg",
    "https://cdn.faire.com/fastly/d590d2ee59f7774155932a37eb49f1409f7b012a73d71e01e289ce984e77eeb7.jpeg",
    "https://cdn.faire.com/fastly/350cbdeb42e2875fd911bca59e0f494b14622a5414438810a8f606b9f34d23bf.jpeg",
    "https://cdn.faire.com/fastly/4455ad965fc438a4e4876c724c81d51130bcc9dd828654a05be206e683e692cd.jpeg",
    "https://cdn.faire.com/fastly/9562abbb4aea0f7d6d2a65d4cba833f0029e5eaf2f0cb5d3c8e4b49519eb402c.jpeg",
    "https://cdn.faire.com/fastly/c09626e4fdc635a95c210a5eaa0e7aa3a72e2f2bc638eef60d086e97b86cb0bd.jpeg",
  ],
  priceDollars: 25.5,
  description:
    "\n * Energy Stones for Dogs 25 Pounds & Up: MAXIMUM EMF Protection with Shungite, Black Tourmaline, Orgonite + Secret Synergy Stones Proprietary Crystal Blend. \n * 5G, EMF & Harmful Radiation: In today's society it's impossible to avoid potentially harmful Electromagnetic Fields. Shungite may be used to block or diminish EMFs. \n * Added benefit ~ May also relieve anxiety & stress & inflammation/pain. Secret Synergy Stone pendants resonate the energy field with the Earth's energy field, releasing negative ions, promoting blood circulation and supporting healthy metabolism. Enhances mental focus and may be beneficial in enhancing the body's optimal balance for versatile health. May help to strengthen the body's natural defensive ability. Boost your pets health with the power of Secret Synergy Stones. \n * All items are handmade using real stones. Weight, size, shape & color may vary. Your selected choice is one-of-a-kind piece created lovingly with positive energy. ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:12.123Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
